function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_13004",
  "data-name": "Path 13004",
  d: "M0,0H24V24H0ZM10,5h4V7H10Zm0,0h4V7H10Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_13005",
  "data-name": "Path 13005",
  d: "M10,16V15H3.01L3,19a1.993,1.993,0,0,0,2,2H19a1.993,1.993,0,0,0,2-2V15H14v1ZM20,7H15.99V5l-2-2h-4l-2,2V7H4A2.006,2.006,0,0,0,2,9v3a1.993,1.993,0,0,0,2,2h6V12h4v2h6a2.006,2.006,0,0,0,2-2V9A2.006,2.006,0,0,0,20,7ZM14,7H10V5h4Z",
  fill: "#fff"
});

function SvgBusinessFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "business_center_black_24dp_1_",
    "data-name": "business_center_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessFocused);
export default __webpack_public_path__ + "static/media/business_focused.a28fa98f.svg";
export { ForwardRef as ReactComponent };